import { render, staticRenderFns } from "./IrisChip.vue?vue&type=template&id=2649e24a&"
import script from "./IrisChip.vue?vue&type=script&lang=ts&"
export * from "./IrisChip.vue?vue&type=script&lang=ts&"
import style0 from "./IrisChip.vue?vue&type=style&index=0&id=2649e24a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports